import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import AdAccountGroupEditRoutes from './routes'

const AdAccountGroupEdit = () => {
  const { adAccountGroupId } = useNumericParams()

  useReduxAction(
    'adAccountGroups',
    'loadAdAccountGroup',
    {
      entityId: adAccountGroupId,
    },
    [adAccountGroupId],
    {
      dispatchAction: (action, requestOptions) => action(adAccountGroupId, requestOptions),
      shouldPerformFn: ({ loading }) => !!adAccountGroupId && !loading,
    },
  )

  return (
    <AdAccountGroupEditRoutes />
  )
}

export default AdAccountGroupEdit
